import { z } from "zod";

import { zRes401 } from "./common";

import { AdminPanelServicePorts } from "~/entities/admin-panel/model";
import { Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(
  200,
  z.object({
    values: AdminPanelServicePorts.ProviderIos.GetRevenueForYear.zOut,
  }),
);

const zRes = Response.Schema.zAggregated([zRes200, zRes401]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
